"use client";

import { AuthProvider } from "@jace/auth/react";
import { usePostHog } from "posthog-js/react";

export const GoogleAuthProvider = ({
	children,
}: { children: React.ReactNode }) => {
	const posthog = usePostHog();

	const authUrl = new URL(`${process.env.NEXT_PUBLIC_API_URL}`);
	const existingSearchParams = new URLSearchParams(window.location.search);
	const testUser = existingSearchParams.get("test_user");

	// NOTE: (bwilytsch): This is needed for tests I believe
	if (testUser) {
		authUrl.searchParams.set("test_user", testUser);
	}

	const posthogSessionId = posthog.get_session_id();

	if (posthogSessionId) {
		authUrl.searchParams.set("ph_session_id", posthogSessionId);
	}

	return (
		<AuthProvider
			provider={{
				name: "google",
				flowType: "simple",
				oneTap: true,
			}}
			appUrl={authUrl.toString()}
			fallbackRedirectUrl={`${process.env.NEXT_PUBLIC_APP_URL}/getting-started`}
		>
			{children}
		</AuthProvider>
	);
};
